import { render } from "./BuildingList.vue?vue&type=template&id=462acefa&scoped=true"
import script from "./BuildingList.vue?vue&type=script&lang=js"
export * from "./BuildingList.vue?vue&type=script&lang=js"

import "./BuildingList.vue?vue&type=style&index=0&id=462acefa&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462acefa"]])

export default __exports__